export const SECTIONS = {
  POLICY_WORDING: { name: "POLICY_WORDING", isMultiple: false, isRisk: false },
  MRC1: { name: "MRC1", isMultiple: false, isRisk: false },
  MRC1_ATTACHMENTS: { name: "MRC1_ATTACHMENTS", isMultiple: false, isRisk: false },
  MRC2: { name: "MRC2", isMultiple: false, isRisk: false },
  MRC2_ATTACHMENTS: { name: "MRC2_ATTACHMENTS", isMultiple: false, isRisk: false },
  PREMIUM_SCHEDULE: { name: "PREMIUM_SCHEDULE", isMultiple: false, isRisk: false },
  PREMIUM_SCHEDULE_ATTACHMENTS: { name: "PREMIUM_SCHEDULE_ATTACHMENTS", isMultiple: false, isRisk: false },
  PREMIUM_CALCULATIONS: { name: "PREMIUM_CALCULATION", isMultiple: false, isRisk: false },
  DECLARATION: { name: "DECLARATION", isMultiple: false, isRisk: false },
  
};

export const QUESTIONS = {
  MRC1_Custom: 1942,
  MRC1_Connection: 1943,
  MRC1_Attachments: 1961,
  MRC2_Custom: 1944,
  MRC2_Connection: 1945,
  MRC2_Attachments: 1962,
  INCLUDE_DECLARATION: 1946,
  DECLARATION_ATTACHMENTS: 1954,
  PREMIUM_CALCULATION_ATTACHMENT: 1977,
  BROKERAGE_PAGE: 1950,
  PREMIUM_SCHEDULE_Connection: 1947,
  PREMIUM_SCHEDULE_Attachments: 1979,
  POLICY_WORDING_Attachments: 1941
};

export const PRODUCTS = {
  UK_Standalone_Policy: [12, 26],
  UK_Declarations: [16],
  USA_Standalone_Policy: [47],
  Singapore_Standalone_Policy: [36],
};

export const onValidationError = (e, mc, formikRef, questionnaire, groupQuestionnaires) => {
  mc.error('Please complete all required fields to proceed.')
  mc.error(e.message);
}

export const getQuestionIsDisabled = (isBound) => {
  if (isBound) return true;
  return false;
};

export const removeAnswersDuplicateSession = (questions) => {
  questions = JSON.parse(JSON.stringify(questions));
  return questions.map((question) => {
    const { defaultValue } = question.behaviorObject || {};
    question.answer = defaultValue || "";
    question.answerJson = defaultValue || "";
    question.idAnswerOption = null;
    question.idPerson = null;
    question.idQuestionnaireAnswers = null;
    question.idQuestionnaireAnswersParent = null;
    question.idQuestionnaireAnswersRoot = null;
    question.key = null;
    return question;
  });
};
